import React, { useState } from "react";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simulate form submission
    setTimeout(() => {
      setSuccessMessage("✅ Your message has been sent successfully!");
      setFormData({ name: "", email: "", message: "" });

      // Hide message after 4 seconds
      setTimeout(() => setSuccessMessage(""), 4000);
    }, 500);
  };

  return (
    <section className="contact-section">
      {/* <p className="contact-top-text">
        We'd love to hear from you! Reach out to us anytime.
      </p> */}
      <div class="contact-header">
  We'd love to hear from you! Reach out to us anytime.
</div>

      <div className="contact-container">
        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleSubmit} aria-label="Contact form">
          <h2>Send us a Message</h2>

          <input
            type="text"
            placeholder="Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            aria-required="true"
          />
          <input
            type="email"
            placeholder="Your Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            aria-required="true"
          />
          <textarea
            placeholder="Your Message"
            name="message"
            rows="6"
            value={formData.message}
            onChange={handleChange}
            required
            aria-required="true"
          ></textarea>

          <button type="submit">Send Message</button>

          {successMessage && <p className="success-message" role="alert">{successMessage}</p>}
        </form>

        {/* Contact Info */}
        <aside className="contact-info" aria-label="Contact information">
          <h2>Our Address</h2>

          <p>
            <svg
              aria-hidden="true"
              focusable="false"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="#e03e2f"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 8 }}
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.88 16.19 7 11.88 7 9z" />
              <circle cx="12" cy="9" r="2.5" />
            </svg>
            Chowk Shah Abbas , Suraj Kund Road, Multan
          </p>

          <p>
            <svg
              aria-hidden="true"
              focusable="false"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="#e03e2f"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 8 }}
            >
              <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21 12.27 12.27 0 003.88 1.17 1 1 0 01.89 1V20a1 1 0 01-1 1A17 17 0 013 5a1 1 0 011-1h3.5a1 1 0 011 .89 12.27 12.27 0 001.17 3.88 1 1 0 01-.21 1.11l-2.84 2.91z" />
            </svg>
         +92 304 7630462 
          </p>

          <p>
            <svg
              aria-hidden="true"
              focusable="false"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="#e03e2f"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 8 }}
            >
              <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v.01L12 13 4 6.01V6h16zM4 18v-8l8 5 8-5v8H4z" />
            </svg>
            academicgroupofschools@gmail.com
          </p>

          <h2 style={{ marginTop: "30px" }}>Find us on Map</h2>
          <div className="map-container" aria-label="Map location">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13622.229915418517!2d71.4653778!3d30.1701592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b3229a52ab4ad%3A0x123456789abcdef!2s5FC7%2B3X9%2C%20Road%2C%20Naveed%20Town%2C%20Multan%2C%20Pakistan!5e0!3m2!1sen!2s!4v1694936502045!5m2!1sen!2s"
              loading="lazy"
              title="Map to My School"
              style={{ border: 0 }}
              allowFullScreen
            ></iframe>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Contact;
